import Cookies from 'js-cookie';
import { COOKIE_SAT_TRACK, ONE_YEAR } from '@yme/components/Cookies/constants';
export const setAllowedCookies = (isAllCookiesAllowed) => {
    if (isAllCookiesAllowed) {
        return {
            allCookies: 'true',
        };
    }
    return {
        allCookies: 'false',
    };
};
export const allowCookies = (isAllow) => {
    const value = setAllowedCookies(isAllow);
    Cookies.set(COOKIE_SAT_TRACK, JSON.stringify(value), {
        expires: ONE_YEAR,
    });
};
export const callOptanonWrapper = () => {
    if (window.OptanonWrapper) {
        window.OptanonWrapper();
    }
};
